import {
    Box,
    useTheme,
    Typography,
    Switch,
    Button,
    TextField,
    useMediaQuery,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    Paper,
    TableBody,
    Avatar,
} from "@mui/material";
import logo from "../../assets/buzz.png";
// import mark from "../../assets/mark.jpg";
import enabledlocation from "../../assets/enabledlocation.svg";
import male from "../../assets/maleinstant.svg";
import { width } from "@mui/system";

import {
    GoogleMap,
    InfoWindow,
    InfoWindowF,
    Marker,
    MarkerF,
    useLoadScript,
} from "@react-google-maps/api";
import React, { useMemo, useState, useEffect } from "react";
import { json, Link, useLocation } from "react-router-dom";
import { tokens } from "../../Theme/theme";
import { format, set } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import { Header } from "../global/Header";
import { Add, ArrowBackIosNewRounded, ArrowDownwardRounded, ArrowRightAltRounded, CalendarMonthRounded, ContentCopy, CopyAll, Download, DownloadDoneOutlined, DownloadOutlined, LinkRounded, LocationOn } from "@mui/icons-material";
import '../Users/MapStyle.css'
import BASE_URL from "../../NetworkConfig/ApiConfig";
import Statbox from "../Dashborad/Statbox";


function useQuery() {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
}

const ClubDetailScreen = () => {
    return <CommunityListView />;
};

function CommunityListView({ data }) {

    const query = useQuery()
    const theme = useTheme();
    const isMobileScreen = useMediaQuery('(max-width:500px)');
    const isTabScreen = useMediaQuery('(max-width:1200px)')
    const [metrics, setMetrics] = useState({})
    const [clubDetails, setClubDetails] = useState({})
    const [currentPage, setCurrentPage] = useState(1)
    const [hasEnded, setHasEnded] = useState(false)
    const [limit, setLimnit] = useState(30)
    const [registrations, setRegistrations] = useState([])
    const [additinalQuestions, setAdditionalQuestions] = useState([])

    useEffect(() => {
        getClubDetails()
        // getEventRegistrations(1)
    }, []);


    const getClubDetails = async () => {
        const token = localStorage.getItem("token");
        const response = await fetch(`${BASE_URL}/clubs/get-club-details/${query.get("ref")}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "auth-token": token,
            },
        });
        const data = await response.json();
        if (data.success === true) {
            setClubDetails(data.response)
        } else {
            alert(data.response)
        }

    };

    const getEventRegistrations = async (page) => {
        if (page == 1) {
            setRegistrations([])
            setHasEnded(false)
        }
        const token = localStorage.getItem("token");
        const response = await fetch(`${BASE_URL}/community/get-event-registrations/${query.get("ref")}?page=${page}&limit=${limit}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "auth-token": token,
            },
        });
        const data = await response.json();
        if (data.success === true) {
            setRegistrations(prev => page == 1 ? data.response : [...prev, ...data.response])
            setCurrentPage(page)
            if (data.response.length < limit) {
                setHasEnded(true)
            }
        } else {
            alert(data.response)
        }

    };


    function formatMongoTime(dateInput, format = "DD MMMM YYYY, hh:mm A") {
        const date = new Date(dateInput);

        const map = {
            DD: String(date.getDate()).padStart(2, "0"),
            MMMM: date.toLocaleString("en-US", { month: "long" }),   // FULL MONTH
            MMM: date.toLocaleString("en-US", { month: "short" }),
            MM: String(date.getMonth() + 1).padStart(2, "0"),
            YYYY: date.getFullYear(),
            YY: String(date.getFullYear()).slice(-2),
            hh: String((date.getHours() % 12) || 12).padStart(2, "0"),
            HH: String(date.getHours()).padStart(2, "0"),
            mm: String(date.getMinutes()).padStart(2, "0"),
            ss: String(date.getSeconds()).padStart(2, "0"),
            A: date.getHours() >= 12 ? "PM" : "AM"
        };

        return format.replace(/MMMM|MMM|DD|MM|YYYY|YY|hh|HH|mm|ss|A/g, m => map[m]);
    }

    const dpr = window.devicePixelRatio || 1;



    return (
        <>
            <Box m={"20px"} flexDirection={'column'} display={'flex'} alignSelf={"stretch"}>

                <Box
                    display={"flex"}
                    flexDirection={(isMobileScreen || isTabScreen) ? "column" : "row"}
                    alignSelf={"stretch"}
                    width={"100%"}
                    pb={"20px"}
                    sx={{

                    }}
                    gap={(isMobileScreen || isTabScreen) ? "20px" : "20px"}
                >
                    {/* ROW 1 */}
                    <Box

                        sx={{
                            borderRadius: "20px",
                            border: "1.7px solid transparent",
                            background: "#ffffff08",
                            flexDirection: "column",
                            padding: "20px",
                            position: "relative",
                            width: isMobileScreen ? "100%" : isTabScreen ? "90%" : "40%"
                        }}
                        display="flex"
                    >

                        <Box sx={{ flexDirection: "column", display: "flex", }} >

                            <Box sx={{
                                width: "100%", height: "150px", background: "#ffffff08", borderRadius: "15px", position: "relative",
                                overflow: "hidden"
                            }} >
                                {
                                    clubDetails?.banner && (
                                        <img
                                            width={"100%"}
                                            height={"100%"}
                                            alt="club_banner"
                                            src={`${clubDetails?.banner ?? ""}`}
                                            style={{
                                                background: "#101010",
                                                cursor: "pointer", objectFit: 'cover',
                                                border: "0px solid #ffffff05"
                                            }}
                                        />
                                    )
                                }
                            </Box>

                            <Box sx={{ display: "flex", alignSelf: "stretch", position: "relative", flexDirection: "row" }} >

                                <Box sx={{
                                    display: 'flex', alignItems: 'center', width: isMobileScreen ? "100%" : "100px",
                                    flexDirection: "column", height: isMobileScreen ? "auto" : "100px", aspectRatio: 1 / 1, position: "relative",
                                    marginTop: "-50px"
                                }}>
                                    <img
                                        width={"100%"}
                                        alt="club_logo"
                                        src={`${clubDetails?.clubLogo ?? ""}`}
                                        style={{
                                            background: "#101010",
                                            aspectRatio: 1 / 1,
                                            cursor: "pointer", objectFit: 'cover',
                                            borderRadius: "105px",
                                            border: "2px solid #ffffff05"
                                        }}
                                    />

                                </Box>

                                <Box sx={{ flex: 1, display: "flex" }} />

                                <Typography color={"#ffffff"}
                                    fontFamily={"poppins-reg"}
                                    style={{
                                        alignSelf: "flex-start",
                                        paddingBlock: "9px",
                                        cursor: "pointer",
                                        paddingInline: "14px",
                                        border: "1px solid #ffffff00",
                                        borderRadius: "8px",
                                        display: "flex",
                                        background: "#ffffff08",
                                        gap: "5px",
                                        alignItems: "center",
                                        flexDirection: "row",
                                        marginTop: "10px"
                                    }}
                                    fontSize={"13px"}>{(((clubDetails.followersCount ?? 0) + (clubDetails?.adminsCount ?? 0) + (clubDetails?.coreMembersCount ?? 0)) ?? 0)} Followers</Typography>

                                {
                                    clubDetails._id && (
                                        <Typography onClick={async () => {
                                            try {
                                                await navigator.clipboard.writeText(clubDetails._id ? clubDetails._id : "");
                                                console.log("Copied to clipboard!");
                                                alert("Club id copied to clipboard.")
                                            } catch (err) {
                                                console.error("Failed to copy:", err);
                                            }
                                        }} color={"#ffffff"}
                                            fontFamily={"poppins-reg"}
                                            fontSize={"14px"}
                                            style={{
                                                alignSelf: "stretch",
                                                paddingBlock: "6px",
                                                marginLeft: "5px",
                                                cursor: "pointer",
                                                paddingInline: "12px",
                                                border: "1px solid #ffffff00",
                                                borderRadius: "8px",
                                                display: "flex",
                                                background: "#ffffff08",
                                                gap: "5px",
                                                alignItems: "center",
                                                flexDirection: "row",
                                                marginTop: "10px"
                                            }}
                                        ><ContentCopy style={{ fontSize: "15px" }} /></Typography>
                                    )
                                }
                            </Box>

                            <Box sx={{
                                flexDirection: "column", display: "flex", ml: "5px", mt: "5px"
                            }} >
                                <Typography color={"#ffffff"}
                                    fontFamily={"poppins-reg"}
                                    fontSize={"22px"}
                                    style={{
                                        display: "-webkit-box",
                                        WebkitLineClamp: 4,      // change to 3,4 if needed
                                        WebkitBoxOrient: "vertical",
                                        overflow: "hidden"
                                    }}
                                >{clubDetails.title ?? "Untitled Club"}</Typography>

                                <Typography color={"#aaaaaa"}
                                    fontFamily={"poppins-reg"}
                                    style={{
                                        marginTop: "0px",
                                        display: "flex",
                                        gap: "5px",
                                        flexDirection: "row",
                                        alignItems: "center"
                                    }}
                                    fontSize={"14px"}>{clubDetails.locationName ?? "Location not available"}</Typography>

                                <Box sx={{ flexDirection: "row", gap: "5px", alignItems: "center", display: "flex", flexWrap: "wrap", marginLeft: "-3px" }} >

                                    <Typography color={clubDetails.isPaid ? "#ff8800" : "#ffffff"}
                                        fontFamily={"poppins-reg"}
                                        fontSize={"14px"}
                                        style={{
                                            alignSelf: "flex-start",
                                            paddingBlock: "9px",
                                            paddingInline: "13px",
                                            background: "#ffffff08",
                                            borderRadius: "8px",
                                            border: "1px solid #ffffff08",
                                            marginTop: "10px"
                                        }}
                                    >{clubDetails?.clubType != "other" ? `${clubDetails.clubType} Club` : "Directory"}</Typography>


                                    {
                                        clubDetails.space && (
                                            <Typography color={"#ab67ff"}
                                                fontFamily={"poppins-reg"}
                                                fontSize={"14px"}
                                                style={{
                                                    alignSelf: "flex-start",
                                                    paddingBlock: "9px",
                                                    paddingInline: "13px",
                                                    background: "#ab67ff10",
                                                    borderRadius: "8px",
                                                    border: "1px solid #ab67ff20",
                                                    marginTop: "10px", display: "flex", flexDirection: "row", alignItems: "center",
                                                    gap: "3px"
                                                }}
                                            ><LinkRounded style={{ color: "#ab67ff" }} />{"Cerkle Campus"}</Typography>

                                        )
                                    }


                                </Box>





                            </Box>




                        </Box>

                        <Box sx={{ height: "1px", background: "#aaaaaa10", marginTop: "20px", marginBottom: "15px" }} />


                        <Typography color={"#aaaaaa"}
                            fontFamily={"poppins-reg"}
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                marginTop: "0px"
                            }}
                            fontSize={"14px"}>About</Typography>

                        <Typography color={"#ffffff"}
                            fontFamily={"poppins-reg"}
                            style={{
                                display: "flex",
                                marginTop: "5px",
                                flexDirection: "row",
                                alignItems: "center"
                            }}
                            fontSize={"16px"}>{clubDetails.description ?? "Description not found"}</Typography>


                        {/*  <Box sx={{
                                        display: 'flex', alignItems: 'center', alignSelf: 'stretch',
                                        position: "relative", flexDirection: "column", width: "300px", height: "300px"
                                    }}>
                                        <img
                                            alt="profile-user"
                                            width={"100%"}
                                            src={`${clubDetails.banner}`}
                                            style={{
                                                aspectRatio: 1 / 1,
                                                cursor: "pointer", objectFit: 'cover',
                                                borderRadius: "15px",
                                                border: "2px solid #ffffff05"
                                            }}
                                        />

                                        <Box sx={{ width: "100%", height: "100%", position: "absolute", background: "#00000010" }} />



                                    </Box> */}


                        <Typography color={"#aaaaaa"}
                            fontFamily={"poppins-reg"}
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                marginTop: "15px"
                            }}
                            fontSize={"14px"}>Upcoming or Ongoing Events</Typography>


                            <Box sx={{flexDirection: "row", alignItems:"center", display: "flex", gap: "10px"}}>



                            </Box>


                    </Box>
                    <Box

                        sx={{
                            borderRadius: "20px",
                            border: "1.7px solid transparent",
                            background: "#ffffff08",
                            flexDirection: "column",
                            padding: "20px",
                            position: "relative",
                            width: isMobileScreen ? "100%" : isTabScreen ? "90%" : "40%"
                        }}
                        display="flex"
                    >

                        <Box sx={{ flexDirection: isMobileScreen ? "column" : "row", alignItems: isMobileScreen ? "stretch" : "center", display: "flex", gap: "10px" }} >

                            <Box
                                sx={{
                                    background: "#ffffff08",
                                    borderRadius: "20px",
                                    border: "1.5px solid #aaaaaa05",
                                }}
                                display="flex"
                                flex={isMobileScreen ? undefined : 1}
                                py={"14px"}
                                alignItems={"center"}
                                justifyContent="center"
                            >
                                <Statbox
                                    // todayonboardusers
                                    title={clubDetails?.registered?.length ?? 0}
                                    subtitle="Total Registrations"
                                    showIcon={false}
                                    titleTextSize="18px"
                                    subtitleTextSize="12px"
                                    onClick={() => {

                                    }}

                                    users={true}
                                />
                            </Box>

                            <Box
                                sx={{
                                    background: "#ffffff08",
                                    borderRadius: "20px",
                                    border: "1.5px solid #aaaaaa05",
                                }}
                                display="flex"
                                flex={isMobileScreen ? undefined : 1}
                                py={"14px"}
                                alignItems={"center"}
                                justifyContent="center"
                            >
                                <Statbox
                                    // todayonboardusers
                                    title={metrics.totalSoldTickets ?? 0}
                                    showIcon={false}
                                    titleTextSize="18px"
                                    subtitleTextSize="12px"
                                    subtitle="Tickets Sold"
                                    onClick={() => {

                                    }}
                                    users={true}
                                />
                            </Box>

                            {
                                clubDetails.isPaid && (
                                    <Box
                                        sx={{
                                            background: "#ffffff08",
                                            borderRadius: "20px",
                                            border: "1.5px solid #aaaaaa05",
                                        }}
                                        display="flex"
                                        flex={isMobileScreen ? undefined : 1}
                                        py={"14px"}
                                        alignItems={"center"}
                                        justifyContent="center"
                                    >
                                        <Statbox
                                            // todayonboardusers
                                            title={`₹${(metrics.totalCollectedAmount ?? 0).toFixed(2)}`}
                                            subtitle="Amount Received"
                                            showIcon={false}
                                            titleTextSize="18px"
                                            subtitleTextSize="12px"
                                            onClick={() => {

                                            }}

                                            users={true}
                                        />
                                    </Box>
                                )
                            }

                        </Box>

                        <Typography color={"#aaaaaa"}
                            fontFamily={"poppins-reg"}
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                marginInline: "3px",
                                marginTop: "10px"
                            }}
                            fontSize={"14px"}>Registered users</Typography>

                        <Box sx={{
                            flexDirection: "column", display: "flex", minHeight: "500px", maxHeight: "600px",
                            overflow: "scroll", gap: "10px"
                        }} >
                            {
                                registrations.map((item, index) => (
                                    <Box sx={{
                                        flexDirection: "row", alignItems: "center", display: "flex",
                                        background: "#ffffff08",
                                        paddingInline: "15px",
                                        paddingBlock: "10px",
                                        borderRadius: "15px",
                                        marginTop: index == 0 ? "10px" : "0px",
                                        gap: "10px"
                                    }} >

                                        <Box sx={{
                                            width: 40,
                                            height: 40,
                                            borderRadius: "50%",
                                            overflow: "hidden",
                                            flexShrink: 0,
                                        }}>
                                            <Avatar
                                                src={item.image[0] ?? ""}
                                                imgProps={{
                                                    referrerPolicy: "no-referrer",
                                                    decoding: "async",
                                                    style: {
                                                        width: `${40 * dpr}px`,
                                                        height: `${40 * dpr}px`,
                                                        transform: `scale(${1 / dpr})`,
                                                        transformOrigin: "top left",
                                                        imageRendering: "auto"
                                                    }
                                                }}
                                                sx={{
                                                    width: 40,
                                                    height: 40,
                                                    border: "2px solid #ffffff05",
                                                    bgcolor: "#111",
                                                }}
                                            />
                                        </Box>

                                        <Box sx={{
                                            flexDirection: "column",
                                            display: "flex",
                                            flex: 1
                                        }} >

                                            <Typography color={"#ffffff"}
                                                fontFamily={"poppins-reg"}
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    alignItems: "center",
                                                }}
                                                fontSize={"14px"}>{item.full_name}</Typography>
                                            <Typography color={"#aaaaaa"}
                                                fontFamily={"poppins-reg"}
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    alignItems: "center",
                                                }}
                                                fontSize={"12px"}>{item.buzz_name}</Typography>

                                        </Box>

                                    </Box>
                                ))
                            }

                            {
                                hasEnded && (
                                    <Box sx={{
                                        marginTop: "20px", marginBottom: "30px", color: "#ffffff90", alignSelf: "center",
                                        fontFamily: "poppins-reg", fontSize: "12px"
                                    }} >- That's all for now -</Box>
                                )
                            }

                            {
                                !hasEnded && registrations.length > 0 && (
                                    <Box onClick={() => {
                                        if (!hasEnded) {
                                            getEventRegistrations(currentPage + 1)
                                        }
                                    }} sx={{
                                        alignSelf: "center", paddingBlock: "8px", paddingInline: "30px", marginBottom: "20px", marginTop: "10px",
                                        fontFamily: "poppins-reg", fontSize: "13px", borderRadius: "10px", border: "1px solid #943bff",
                                        background: "#943bff20", cursor: "pointer",
                                    }} >Load More</Box>
                                )
                            }
                        </Box>





                    </Box>

                </Box>

                <Box display={"flex"} flexDirection={'column'} alignSelf={'stretch'} alignItems={'stretch'}>





                    {/* <Typography style={{ fontSize: "25px", fontFamily: "poppins-reg", color: "#f0f0f0", marginBottom: "20px" }} gutterBottom></Typography> */}




                </Box>

            </Box>
        </>
    );
}

export default ClubDetailScreen;
